module.exports = __webpack_public_path__ + "assets/img/text-to-speech-case1.30a28602.png";